module.exports = __webpack_public_path__ + "static/media/bg.71f43c9b.png";